module.exports = __webpack_public_path__ + "static/media/preloader-SMALL-Doma-Combined.07980f69.gif";